import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { borderRadius, size } from '@twisto/styles'

export const list = (theme: Theme) => css`
  list-style: none;
  margin: ${size[8]} 0 0 ${size[16]};
  padding: 0;

  display: grid;
  gap: ${size[8]};
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -${size[16]};

    height: 100%;
    width: ${size[4]};
    background-color: ${theme.palette.neutral[100]};
    border-radius: ${borderRadius.md};
  }
`
